import React, { useRef } from "react"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_green.css" // Import the desired theme
import moment from "moment" // For date formatting

const DatePicker = ({
  value,
  onChange,
  name,
  disabled,
  placeholder,
  minDate,
  maxDate,
}) => {
  const dateInputRef = useRef(null)

  return (
    <Flatpickr
      ref={dateInputRef}
      className="form-control"
      name={name || ""}
      placeholder={placeholder || ""}
      disabled={disabled || false}
      options={{
        altInput: true,
        dateFormat: "YYYY-MM-DD",
        altFormat: "DD-MM-YYYY",
        minDate: minDate && minDate !== "" ? moment(minDate).format("YYYY-MM-DD") : undefined,
        defaultDate: maxDate && maxDate !== "" ? moment(maxDate).format("YYYY-MM-DD") : undefined,
        allowInput: true,
        parseDate: (datestr, format) => moment(datestr, format, true).toDate(),
        formatDate: (date, format, locale) => moment(date).format(format),
      }}
      value={value ? moment(new Date(value)).format("YYYY-MM-DD"):""}
      onChange={selectedDates => {
        onChange({
          target: {
            name,
            value: moment(new Date(selectedDates[0])).format("YYYY-MM-DD"),
          },
        })
      }}
    />
  )
}

export default DatePicker
